import { authRequest } from './utils';

export const refetchResume = async (uuid, config = undefined) => {
  const url = `admin/resumes/${uuid}/refetch`;
  return await authRequest.get(url, config);
};
